import { render, staticRenderFns } from "./SearchPageHeader.vue?vue&type=template&id=94d4effe&scoped=true"
import script from "./SearchPageHeader.vue?vue&type=script&lang=js"
export * from "./SearchPageHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchPageHeader.vue?vue&type=style&index=0&id=94d4effe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d4effe",
  null
  
)

export default component.exports